/*! React Starter Kit | MIT License | http://www.reactstarterkit.com/ */

import React from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import styles from './InstallerEditor.scss';
import BaseReactComponent from '../Util/BaseReactComponent';
import baseComponent from '../../decorators/baseComponent';
import reactMixin from 'react-mixin';
import ProgressButton from '../ProgressButton';
import { connect } from 'react-redux';
import Modal from 'react-bootstrap/lib/Modal';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import ChangePasswordModal from '../ChangePasswordModal';

@connect(state => ({
  user: state.login.user
}))
@baseComponent(styles)
@reactMixin.decorate(LinkedStateMixin)
class InstallerEditor extends BaseReactComponent {
  constructor(props) {
    super(props);

    this.state = {};
    this.state.deleteMode = false;
    this.state.passwordChangeMode = false;
  }

  onAddInstaller() {
    this.setState({
      id: undefined,
      email: '',
      username: '',
      address: '',
      phonenumber: '',
      installerCompany: this.props.user.id,
      editMode: 'NEW'
    });
  }

  editInstaller(i) {
    if (i) {
      i.editMode = 'EDIT';
      delete i.installerCompany;
      this.setState(i);
    }
  }

  onInstallerDelete() {
    if (this.state.deleteMode) {
      this.props.disableInstaller(this.state);

      this.setState({
        id: undefined,
        email: '',
        username: '',
        address: '',
        phonenumber: '',
        installerCompany: this.props.user.id,
        editMode: 'NEW',
        deleteMode: false
      });
    }
  }

  onInstallerAdd() {
    if (this.state.id !== undefined) {
      this.props.updateInstaller(this.state);
    } else {
      this.props.addInstaller(this.state);
    }
    this.setState({
      id: undefined,
      email: '',
      username: '',
      address: '',
      phonenumber: '',
      installerCompany: this.props.user.id,
      editMode: 'NEW',
      deleteMode: false
    });
  }

  onChange(type, event) {
    if (type === 'country') {
      this.setState({ country: event });
    }
  }

  componentDidMount() {
    if (this.props.installer()) {
      this.editInstaller(this.props.installer());
    } else {
      this.onAddInstaller();
    }
  }

  componentWillUpdate(nextProps) {
    if (
      nextProps.installer() !== undefined &&
      (this.state.id !== nextProps.installer().id || this.state.editMode !== 'EDIT') &&
      this.props.installer().editMode === 'EDIT'
    ) {
      this.editInstaller(this.props.installer());
      this.props.installer().editMode = undefined;
    } else if (nextProps.installer() !== undefined && this.props.installer().editMode === 'NEW') {
      this.onAddInstaller();
      this.props.installer().editMode = undefined;
    }
  }

  cancelEdit() {
    this.props.changeTab(0);
    this.setState({
      id: undefined,
      email: '',
      username: '',
      address: '',
      phonenumber: '',
      installerCompany: this.props.user.id,
      editMode: 'NEW',
      deleteMode: false
    });
  }

  startDeleteMode() {
    this.setState({
      deleteMode: true
    });
  }

  stopDeleteMode() {
    this.setState({
      deleteMode: false
    });
  }

  keyup(e) {
    if (e.which === 13) {
      this.onInstallerAdd(e);
    }
  }

  changePassword() {
    this.setState({
      passwordChangeMode: true
    });
  }

  stopChangePassword() {
    this.setState({
      passwordChangeMode: false
    });
  }

  render() {
    let subTitle = this.getMessage(this.state.id !== undefined ? 'edit-installer' : 'add-installer');

    let deleteField = (
      <div className="form-group">
        <label htmlFor="address" className="col-sm-2 control-label">
          {this.getMessage('delete-label')}
        </label>

        <div className="col-sm-6">
          <ProgressButton onClick={this.startDeleteMode.bind(this)}>{this.getMessage('delete-label')}</ProgressButton>
        </div>
      </div>
    );

    let changePasswordButton = (
      <div className="form-group">
        <label htmlFor="address" className="col-sm-2 control-label">
          {this.getIntlMessage('changepasswordpage.change-password-label')}
        </label>

        <div className="col-sm-6">
          <ProgressButton onClick={this.changePassword.bind(this)}>
            {this.getIntlMessage('changepasswordpage.change-password-label')}{' '}
          </ProgressButton>
        </div>
      </div>
    );

    return (
      <div className="InstallerEditor">
        <div className="editor-header">
          <div className="container">
            <h1>{subTitle}</h1>
          </div>
        </div>

        <Modal title="Delete user" onHide={this.stopDeleteMode.bind(this)} show={this.state.deleteMode}>
          <Modal.Header>{this.getMessage('delete-title')}</Modal.Header>

          <Modal.Body>
            <p>
              You are about to delete <b>{this.state.username}</b>
              <br />
              Are you sure?
            </p>
          </Modal.Body>

          <Modal.Footer>
            <a className="btn btn-link" onClick={this.stopDeleteMode.bind(this)}>
              {this.getMessage('cancel-button')}
            </a>
            <a className="btn btn-primary" onClick={this.onInstallerDelete.bind(this)}>
              {this.getMessage('delete-label')}
            </a>
          </Modal.Footer>
        </Modal>

        <ChangePasswordModal
          user={this.state}
          onHide={this.stopChangePassword.bind(this)}
          show={this.state.passwordChangeMode}
        />

        <div className="container">
          <form role="form" className="form-horizontal" onKeyPress={this.keyup.bind(this)}>
            <div className="form-group">
              <label htmlFor="username" className="col-sm-2 control-label">
                {this.getMessage('username-label')}
              </label>

              <div className="col-sm-6">
                <input
                  type="text"
                  className="validate form-control"
                  id="username"
                  valueLink={this.linkState('username')}
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="email" className="col-sm-2 control-label">
                {this.getMessage('email-label')}
              </label>

              <div className="col-sm-6">
                <input type="text" className="validate form-control" id="email" valueLink={this.linkState('email')} />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="address" className="col-sm-2 control-label">
                {this.getMessage('phone-label')}
              </label>

              <div className="col-sm-6">
                <input
                  type="text"
                  className="validate form-control"
                  id="phonenumber"
                  valueLink={this.linkState('phonenumber')}
                />
              </div>
            </div>
            {this.state.id !== undefined ? deleteField : <div />}
            {this.state.id !== undefined ? changePasswordButton : <div />}
            <div className="controls">
              <a className="btn btn-primary" onClick={this.onInstallerAdd.bind(this)}>
                {this.getMessage('save-button')}
              </a>
              <a className="btn btn-link" onClick={this.cancelEdit.bind(this)}>
                {this.getMessage('cancel-button')}
              </a>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

InstallerEditor.propTypes = {
  installer: React.PropTypes.func,
  changeTab: React.PropTypes.func,
  updateInstaller: React.PropTypes.func,
  addInstaller: React.PropTypes.func,
  disableInstaller: React.PropTypes.func
};

InstallerEditor.defaultProps = {
  componentName: 'installer-editor'
};

export default InstallerEditor;



// WEBPACK FOOTER //
// /src/components/InstallerEditor/InstallerEditor.js